import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pi0001',
    ecrans: ['00-2']
});
